import React, { useState } from 'react';
import { Button } from '../../../ui/button';
import { Save } from 'lucide-react';

const ProvisionTab = ({ caseId, caseData, partner, onRefresh, token }) => {
  const [provision, setProvision] = useState({
    netto_grundhonorar: caseData?.netto_grundhonorar || 0,
    kuerzung: caseData?.kuerzung || 0,
    payout_status: caseData?.payout_status || 'open'
  });
  const [saving, setSaving] = useState(false);

  const reguliert = (provision.netto_grundhonorar || 0) - (provision.kuerzung || 0);
  const provisionAmount = reguliert * ((partner?.provision_level || 30) / 100);

  const save = async () => {
    setSaving(true);
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/provision`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(provision)
      });
      onRefresh();
      alert('Provision aktualisiert');
    } catch { alert('Fehler'); } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
        <p className="text-sm text-blue-800">
          <strong>Partner Level:</strong> {partner?.provision_level || 30}%
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-semibold mb-2">Netto Grundhonorar (EUR)</label>
          <input type="number" step="0.01" value={provision.netto_grundhonorar} onChange={e => setProvision({...provision, netto_grundhonorar: parseFloat(e.target.value) || 0})} className="w-full px-4 py-3 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Kürzung (EUR)</label>
          <input type="number" step="0.01" value={provision.kuerzung} onChange={e => setProvision({...provision, kuerzung: parseFloat(e.target.value) || 0})} className="w-full px-4 py-3 border rounded-xl" />
        </div>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <div className="grid md:grid-cols-3 gap-4 text-sm">
          <div>
            <p className="text-gray-600 mb-1">Reguliert (EUR)</p>
            <p className="text-2xl font-bold text-gray-900">{reguliert.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-gray-600 mb-1">Partner Level</p>
            <p className="text-2xl font-bold text-brand-green">{partner?.provision_level || 30}%</p>
          </div>
          <div>
            <p className="text-gray-600 mb-1">Partner Provision (EUR)</p>
            <p className="text-2xl font-bold text-brand-green">{provisionAmount.toFixed(2)}</p>
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-semibold mb-2">Payout Status</label>
        <select value={provision.payout_status} onChange={e => setProvision({...provision, payout_status: e.target.value})} className="w-full px-4 py-3 border rounded-xl">
          <option value="open">Open</option>
          <option value="ready">Ready</option>
          <option value="paid">Paid</option>
        </select>
      </div>

      <Button onClick={save} disabled={saving} size="lg" className="w-full bg-brand-green text-white">
        <Save className="w-5 h-5 mr-2" />{saving ? 'Speichern...' : 'Provision speichern'}
      </Button>
    </div>
  );
};

export default ProvisionTab;
